export default __webpack_public_path__ + "static/bg-spacex-e6bf783fcf9190bf11be79907d9de648.jpg";